import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import api from '../api';
import { Clock, FolderOpen, CalendarOff, TrendingUp } from 'lucide-react';

const Dashboard = () => {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const [recentEntries, setRecentEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];

        const [summaryRes, entriesRes] = await Promise.all([
          api.get(`/time-entries/summary?start_date=${startOfMonth}&end_date=${endOfMonth}`),
          api.get(`/time-entries?start_date=${startOfMonth}&end_date=${endOfMonth}`),
        ]);

        setSummary(summaryRes.data);
        setRecentEntries(entriesRes.data.slice(0, 5));
      } catch (error) {
        console.error('Dashboard-Fehler:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const monthName = new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Willkommen, {user?.first_name}!</h2>
        <p>Übersicht für {monthName}</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label"><Clock size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} /> Arbeitsstunden</div>
          <div className="stat-value">{summary?.total_hours ? parseFloat(summary.total_hours).toFixed(1) : '0.0'}</div>
          <div className="stat-sub">Stunden diesen Monat</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><FolderOpen size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} /> Einträge</div>
          <div className="stat-value">{summary?.total_entries || 0}</div>
          <div className="stat-sub">Zeiteinträge diesen Monat</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><CalendarOff size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} /> Pausen</div>
          <div className="stat-value">{summary?.total_break_minutes ? Math.round(summary.total_break_minutes / 60 * 10) / 10 : '0'}</div>
          <div className="stat-sub">Stunden Pause gesamt</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><TrendingUp size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} /> Durchschnitt</div>
          <div className="stat-value">
            {summary?.total_entries > 0
              ? (parseFloat(summary.total_hours) / parseInt(summary.total_entries)).toFixed(1)
              : '0.0'}
          </div>
          <div className="stat-sub">Stunden pro Eintrag</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">Letzte Zeiteinträge</div>
        <div className="table-container">
          {recentEntries.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Start</th>
                  <th>Ende</th>
                  <th>Pause</th>
                  <th>Projekt</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {recentEntries.map((entry) => (
                  <tr key={entry.id}>
                    <td>{new Date(entry.date).toLocaleDateString('de-DE')}</td>
                    <td>{entry.start_time?.substring(0, 5)}</td>
                    <td>{entry.end_time?.substring(0, 5)}</td>
                    <td>{entry.break_minutes} Min</td>
                    <td>{entry.project_name || '-'}</td>
                    <td><span className={`badge badge-${entry.status}`}>{entry.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="empty-state">
              <Clock size={40} />
              <p>Keine Zeiteinträge in diesem Monat.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
